export const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export const isPasswordValid = (password) => {
    if (!password) {
        return false;
    }
    if (/\s/.test(password)) {
        return false;
    }
    if (password.length < 8) {
        return false;
    }
    if (!/[A-Z]/.test(password)) {
        return false;
    }
    if (!/[0-9]/.test(password)) {
        return false;
    }
    if (!/[-!@#$%^&*]/.test(password)) {
        return false;
    }
    return true;
}